/* Shared article table of contents. The component stays hidden until enough
   eligible sections exist, so a script failure never leaves an empty rail. */
(function () {
  'use strict';

  if (window.BnArticleToc) {
    window.BnArticleToc.boot(document);
    return;
  }

  var MAIN_ID = 'MainContent';
  var HARD_EXCLUDED = [
    '[data-article-toc-exclude]',
    '[data-bn-article-toc]',
    'figcaption',
    'blockquote',
    'details',
    'dialog',
    'table'
  ].join(',');
  var SOFT_EXCLUDED = [
    '[class*="faq"]',
    '[class*="card"]',
    '[class*="caption"]',
    '[class*="quote"]',
    '[class*="cta"]',
    '[class*="disclaimer"]'
  ].join(',');

  function slug(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[‘’“”]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 64);
  }

  function headingText(heading) {
    return String(heading && heading.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isExcludedHeading(heading, boundary, explicit) {
    if (!heading) return true;
    if (heading.closest(HARD_EXCLUDED)) return true;
    var excluded = heading.closest(SOFT_EXCLUDED);
    if (!excluded) return false;
    if (boundary && !boundary.contains(excluded)) return false;
    return !(explicit && excluded === boundary);
  }

  function firstEligibleHeading(root, selector, explicit) {
    var headings = root ? root.querySelectorAll(selector || 'h2') : [];
    for (var i = 0; i < headings.length; i++) {
      if (!isExcludedHeading(headings[i], root, explicit) && headingText(headings[i])) return headings[i];
    }
    return null;
  }

  function parseOverrides(toc) {
    try {
      return JSON.parse(toc.dataset.overrides || '[]')
        .filter(function (item) { return item && item.match; })
        .map(function (item) {
          return {
            match: String(item.match).toLowerCase(),
            label: String(item.label || ''),
            hide: Boolean(item.hide)
          };
        });
    } catch (error) {
      return [];
    }
  }

  function applyOverride(entry, overrides) {
    var lower = entry.label.toLowerCase();
    for (var i = 0; i < overrides.length; i++) {
      if (lower.indexOf(overrides[i].match) === -1) continue;
      if (overrides[i].hide) return null;
      if (overrides[i].label) entry.label = overrides[i].label;
      break;
    }
    return entry;
  }

  function entryForRoot(root, selector, explicit) {
    var direct = root.matches && root.matches('h2,h3');
    var heading = direct ? root : firstEligibleHeading(root, selector, explicit);
    if (direct && isExcludedHeading(heading, root, explicit)) return null;
    if (!heading) return null;
    var label = root.getAttribute && root.getAttribute('data-article-label');
    return {
      heading: heading,
      target: root,
      owner: root.closest('.shopify-section') || root,
      label: label || headingText(heading),
      explicit: Boolean(explicit)
    };
  }

  function collectArticleEntries(toc, main) {
    var selector = toc.dataset.headings || 'h2';
    var entries = [];
    var explicit = Array.prototype.slice.call(main.querySelectorAll('[data-article-section]'));

    if (explicit.length) {
      entries = explicit.map(function (root) { return entryForRoot(root, selector, true); }).filter(Boolean);
    } else {
      var legacy = Array.prototype.slice.call(main.querySelectorAll('.bn3__chapter'));
      if (legacy.length) {
        entries = legacy.map(function (root) { return entryForRoot(root, 'h2', true); }).filter(Boolean);
      } else {
        var singleRoot = toc.closest('[data-bn-single-section-article]');
        var singleSelector = toc.dataset.context === 'single'
          ? '.blog-post-content h2, [data-bn-article-content] h2'
          : '.blog-post-content h2';
        var singleHeadings = Array.prototype.slice.call((singleRoot || main).querySelectorAll(singleSelector))
          .filter(function (heading) {
            var boundary = heading.closest('.blog-post-content, [data-bn-article-content]') || singleRoot || main;
            return !isExcludedHeading(heading, boundary, false) && headingText(heading);
          });
        if (singleHeadings.length) {
          entries = singleHeadings.map(function (heading) {
            return {
              heading: heading,
              target: heading,
              owner: heading.closest('.shopify-section') || heading,
              label: headingText(heading),
              explicit: true
            };
          });
        } else {
          var tocSection = toc.closest('.shopify-section');
          var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
          var skipFirst = toc.dataset.skipFirst === 'true';
          var skippedHero = false;
          sections.forEach(function (section) {
            if (section === tocSection) return;
            if (skipFirst && !skippedHero) {
              skippedHero = true;
              return;
            }
            var entry = entryForRoot(section, selector, false);
            if (entry) entries.push(entry);
          });
        }
      }
    }

    var overrides = parseOverrides(toc);
    return entries.map(function (entry) { return applyOverride(entry, overrides); }).filter(Boolean);
  }

  function ensureUniqueAnchor(entry, usedIds) {
    var existing = entry.target.id;
    if (existing && !usedIds[existing] && document.getElementById(existing) === entry.target) {
      usedIds[existing] = true;
      entry.generatedAnchor = false;
      return existing;
    }
    var base = slug(entry.label) || 'article-section';
    var id = base;
    var suffix = 2;
    while (usedIds[id] || document.getElementById(id)) id = base + '-' + suffix++;
    entry.target.id = id;
    usedIds[id] = true;
    entry.generatedAnchor = true;
    return id;
  }

  function createSectionLayout(toc, entries, main) {
    var tocHost = toc.closest('.shopify-section') || toc.parentElement;
    if (!tocHost || tocHost.closest('.bn-article-layout')) return tocHost && tocHost.closest('.bn-article-layout');
    var owners = entries.map(function (entry) { return entry.owner; })
      .filter(function (owner, index, all) { return owner && owner.parentElement === main && all.indexOf(owner) === index; });
    if (!owners.length) return null;

    var siblings = Array.prototype.slice.call(main.children);
    var first = siblings.indexOf(owners[0]);
    var last = siblings.indexOf(owners[owners.length - 1]);
    if (first < 0 || last < first) return null;

    var layout = document.createElement('div');
    layout.className = 'bn-article-layout';
    layout.setAttribute('data-bn-article-layout', '');
    var rail = document.createElement('div');
    rail.className = 'bn-article-layout__rail';
    var content = document.createElement('div');
    content.className = 'bn-article-layout__content';
    layout.appendChild(rail);
    layout.appendChild(content);
    main.insertBefore(layout, tocHost);
    rail.appendChild(tocHost);
    siblings.slice(first, last + 1).forEach(function (section) {
      if (section !== tocHost) content.appendChild(section);
    });
    return layout;
  }

  function createLegacyLayout(toc, main) {
    var slot = main.querySelector('.bn3__article-aside');
    if (!slot) return null;
    var layout = slot.closest('.bn3__article-body');
    toc.classList.add('bn3__article-aside', 'bn3__article-aside--toc');
    toc.setAttribute('data-bn-legacy-toc-slot', '');
    if (slot !== toc) slot.replaceWith(toc);
    return layout;
  }

  function createSingleSectionLayout(toc) {
    var wrapper = toc.closest('[data-bn-single-section-article]');
    if (!wrapper) return null;
    wrapper.classList.add('bn-article-layout', 'bn-article-layout--single');
    var content = wrapper.querySelector('.blog-post-content, [data-bn-article-content]');
    if (!content) return wrapper;
    var rail = document.createElement('div');
    rail.className = 'bn-article-layout__rail';
    wrapper.insertBefore(rail, toc);
    rail.appendChild(toc);
    content.classList.add('bn-article-layout__content');
    return wrapper;
  }

  var BAND_STYLE_PROPERTIES = [
    ['--bn-article-band-color', 'backgroundColor'],
    ['--bn-article-band-image', 'backgroundImage'],
    ['--bn-article-band-position', 'backgroundPosition'],
    ['--bn-article-band-size', 'backgroundSize'],
    ['--bn-article-band-repeat', 'backgroundRepeat'],
    ['--bn-article-band-origin', 'backgroundOrigin'],
    ['--bn-article-band-clip', 'backgroundClip'],
    ['--bn-article-band-attachment', 'backgroundAttachment'],
    ['--bn-article-band-blend-mode', 'backgroundBlendMode']
  ];

  function hasVisibleBackground(style) {
    return style.backgroundImage !== 'none' || !/^rgba?\(0(?:,?\s*0){2}(?:,?\s*0)?\)$/.test(style.backgroundColor);
  }

  function findBandSource(owner) {
    var children = Array.prototype.slice.call(owner.children || []);
    var source = children.find(function (element) {
      return ['LINK', 'SCRIPT', 'STYLE', 'TEMPLATE'].indexOf(element.tagName) === -1;
    });
    if (source && hasVisibleBackground(window.getComputedStyle(source))) return source;
    return owner;
  }

  function isDarkBackground(color) {
    var channels = String(color || '').match(/[\d.]+/g);
    if (!channels || channels.length < 3) return false;
    if (channels.length > 3 && Number(channels[3]) < 0.5) return false;
    var rgb = channels.slice(0, 3).map(function (channel) {
      var value = Number(channel) / 255;
      return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2] < 0.28;
  }

  function applySectionBands(layout) {
    var content = layout.querySelector('.bn-article-layout__content');
    if (!content) return [];
    return Array.prototype.map.call(content.children, function (owner) {
      var source = findBandSource(owner);
      var style = window.getComputedStyle(source);
      BAND_STYLE_PROPERTIES.forEach(function (property) {
        owner.style.setProperty(property[0], style[property[1]]);
      });
      owner.setAttribute('data-bn-article-band', '');
      return {
        dark: isDarkBackground(style.backgroundColor),
        owner: owner
      };
    });
  }

  function clearSectionBands(bands) {
    (bands || []).forEach(function (band) {
      band.owner.removeAttribute('data-bn-article-band');
      BAND_STYLE_PROPERTIES.forEach(function (property) {
        band.owner.style.removeProperty(property[0]);
      });
    });
  }

  function bandAtLine(bands, line) {
    var current = bands[0] || null;
    for (var i = 0; i < bands.length; i++) {
      var rect = bands[i].owner.getBoundingClientRect();
      if (rect.top <= line && rect.bottom > line) return bands[i];
      if (rect.top <= line) current = bands[i];
    }
    return current;
  }

  function observeBandPalette(toc, bands, top) {
    if (!bands.length) return function () {};
    var line = top + 24;
    var observer = null;
    var resizeFrame = 0;

    function update() {
      var band = bandAtLine(bands, line + 1);
      toc.classList.toggle('bn-alg--on-dark', Boolean(band && band.dark));
    }

    function connect() {
      if (observer) observer.disconnect();
      if (!('IntersectionObserver' in window)) {
        update();
        return;
      }
      var bottomMargin = Math.max(0, window.innerHeight - line - 2);
      observer = new IntersectionObserver(update, {
        root: null,
        rootMargin: '-' + line + 'px 0px -' + bottomMargin + 'px 0px',
        threshold: 0
      });
      bands.forEach(function (band) { observer.observe(band.owner); });
      update();
    }

    function onResize() {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(connect);
    }

    window.addEventListener('resize', onResize);
    connect();
    return function () {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      if (observer) observer.disconnect();
      window.removeEventListener('resize', onResize);
    };
  }

  function setDisclosureMode(toc) {
    var query = window.matchMedia('(min-width: 990px)');
    function update(event) {
      if (event.matches) toc.open = true;
      else if (!toc.dataset.mobileOpened) toc.open = false;
    }
    update(query);
    if (query.addEventListener) query.addEventListener('change', update);
    else if (query.addListener) query.addListener(update);
    function onToggle() {
      if (!query.matches && toc.open) toc.dataset.mobileOpened = 'true';
    }
    toc.addEventListener('toggle', onToggle);
    return function () {
      if (query.removeEventListener) query.removeEventListener('change', update);
      else if (query.removeListener) query.removeListener(update);
      toc.removeEventListener('toggle', onToggle);
    };
  }

  function teardown(toc) {
    var state = toc && toc._bnArticleTocState;
    if (!state) return;
    if (state.observer) state.observer.disconnect();
    if (state.cleanupBandObserver) state.cleanupBandObserver();
    if (state.cleanupDisclosure) state.cleanupDisclosure();
    if (state.cleanupTracking) state.cleanupTracking();
    if (state.clippingArticle) state.clippingArticle.classList.remove('bn3--article--toc-ready');
    if (state.list && state.onClick) state.list.removeEventListener('click', state.onClick);
    if (state.list && state.onFocus) state.list.removeEventListener('focusin', state.onFocus);
    state.links.forEach(function (item) {
      item.target.removeAttribute('data-bn-article-anchor');
      if (item.generatedAnchor && item.target.id === item.id) item.target.removeAttribute('id');
      if (item.addedTabindex) item.target.removeAttribute('tabindex');
    });
    if (state.list) {
      state.list.style.removeProperty('--bn-alg-list-shift');
      state.list.replaceChildren();
    }
    if (state.sentinel) state.sentinel.remove();
    clearSectionBands(state.bands);

    if (state.context === 'sections' && state.layout && state.layout.parentElement) {
      var parent = state.layout.parentElement;
      var host = state.tocHost;
      var content = state.layout.querySelector('.bn-article-layout__content');
      if (host && host.parentElement) parent.insertBefore(host, state.layout);
      while (content && content.firstChild) parent.insertBefore(content.firstChild, state.layout);
      state.layout.remove();
    } else if (state.context === 'single' && state.layout) {
      var singleContent = state.layout.querySelector('.bn-article-layout__content');
      var rail = state.layout.querySelector('.bn-article-layout__rail');
      if (singleContent && rail) state.layout.insertBefore(toc, singleContent);
      if (rail) rail.remove();
      if (singleContent) singleContent.classList.remove('bn-article-layout__content');
      state.layout.classList.remove('bn-article-layout', 'bn-article-layout--single', 'bn-article-layout--ready');
    }

    toc.hidden = true;
    toc.open = false;
    toc.classList.remove('bn-alg--on-dark');
    delete toc.dataset.mobileOpened;
    delete toc.dataset.bnArticleTocReady;
    delete toc._bnArticleTocState;
  }

  function build(toc) {
    if (toc.dataset.bnArticleTocReady === 'true') return;
    var main = document.getElementById(MAIN_ID);
    if (!main) return;
    var entries = collectArticleEntries(toc, main);
    var minimum = parseInt(toc.dataset.min, 10) || 2;
    if (entries.length < minimum) return;

    var list = toc.querySelector('[data-bn-article-toc-list]');
    if (!list) return;
    var context = toc.dataset.context || 'sections';
    var tocHost = toc.closest('.shopify-section') || toc.parentElement;
    var layout = context === 'legacy' ? createLegacyLayout(toc, main)
      : context === 'single' ? createSingleSectionLayout(toc)
        : createSectionLayout(toc, entries, main);
    if (!layout) return;
    var bands = context === 'sections' ? applySectionBands(layout) : [];
    var clippingArticle = layout.closest('.bn3--article');
    if (clippingArticle) clippingArticle.classList.add('bn3--article--toc-ready');

    var usedIds = Object.create(null);
    var links = [];
    entries.forEach(function (entry) {
      var id = ensureUniqueAnchor(entry, usedIds);
      entry.target.setAttribute('data-bn-article-anchor', '');
      var addedTabindex = !entry.target.hasAttribute('tabindex');
      if (addedTabindex) entry.target.setAttribute('tabindex', '-1');
      var item = document.createElement('li');
      item.className = 'bn-alg__item';
      var link = document.createElement('a');
      link.className = 'bn-alg__link';
      link.href = '#' + id;
      link.textContent = entry.label;
      item.appendChild(link);
      list.appendChild(item);
      links.push({
        link: link,
        target: entry.target,
        id: id,
        generatedAnchor: entry.generatedAnchor,
        addedTabindex: addedTabindex
      });
    });

    var top = parseInt(toc.dataset.top, 10) || 132;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var activeIndex = -1;
    var cleanupBandObserver = observeBandPalette(toc, bands, top);

    function trackListItem(link) {
      list.scrollTop = 0;
      if (!desktopQuery.matches) {
        list.style.setProperty('--bn-alg-list-shift', '0px');
        return;
      }
      var item = link && link.closest('.bn-alg__item');
      var available = list.clientHeight;
      var contentHeight = list.scrollHeight;
      if (!item || !available || contentHeight <= available + 1) {
        list.style.setProperty('--bn-alg-list-shift', '0px');
        return;
      }
      var items = Array.prototype.slice.call(list.children);
      var origin = items.length ? items[0].offsetTop : 0;
      var itemTop = item.offsetTop - origin;
      var itemBottom = itemTop + item.offsetHeight;
      var itemCenter = itemTop + (item.offsetHeight / 2);
      var maximum = Math.max(0, contentHeight - available);
      var minimum = Math.max(
        0,
        Math.min(maximum, itemCenter - (available / 2)),
        itemBottom - available
      );
      var offset = itemTop;
      for (var i = 0; i < items.length; i++) {
        var boundary = items[i].offsetTop - origin;
        if (boundary >= minimum - 0.5 && boundary <= itemTop + 0.5) {
          offset = boundary;
          break;
        }
      }
      list.style.setProperty('--bn-alg-list-shift', Math.round(0 - offset) + 'px');
    }

    function setActive(index) {
      var next = Math.max(0, Math.min(index, links.length - 1));
      if (next === activeIndex) {
        trackListItem(links[next].link);
        return;
      }
      activeIndex = next;
      links.forEach(function (item, itemIndex) {
        var active = itemIndex === next;
        item.link.classList.toggle('is-active', active);
        if (active) item.link.setAttribute('aria-current', 'location');
        else item.link.removeAttribute('aria-current');
      });
      trackListItem(links[next].link);
    }

    function selectFromGeometry() {
      var line = top + 24;
      var next = 0;
      links.forEach(function (item, index) {
        if (item.target.getBoundingClientRect().top <= line) next = index;
      });
      if (layout.getBoundingClientRect().bottom <= window.innerHeight + 2) next = links.length - 1;
      setActive(next);
    }

    function onClick(event) {
      var link = event.target.closest('.bn-alg__link');
      if (!link) return;
      var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!target) return;
      event.preventDefault();
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      if (mobile) {
        toc.open = false;
        delete toc.dataset.mobileOpened;
      }
      window.requestAnimationFrame(function () {
        var y = window.scrollY + target.getBoundingClientRect().top - top - 20;
        window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
        target.focus({ preventScroll: true });
        if (history.replaceState) history.replaceState(null, '', link.hash);
      });
    }
    list.addEventListener('click', onClick);

    function onFocus(event) {
      var link = event.target.closest('.bn-alg__link');
      if (link && list.contains(link)) trackListItem(link);
    }
    list.addEventListener('focusin', onFocus);

    var trackingFrame = 0;

    function trackedLink() {
      var focused = document.activeElement;
      var focusedLink = focused && focused.closest ? focused.closest('.bn-alg__link') : null;
      if (focusedLink && list.contains(focusedLink)) return focusedLink;
      return links[Math.max(0, activeIndex)].link;
    }

    function scheduleRetrack() {
      if (trackingFrame) window.cancelAnimationFrame(trackingFrame);
      trackingFrame = window.requestAnimationFrame(function () {
        trackingFrame = 0;
        trackListItem(trackedLink());
      });
    }

    function onResize() {
      scheduleRetrack();
    }

    function onDesktopChange() {
      if (!desktopQuery.matches) {
        if (trackingFrame) window.cancelAnimationFrame(trackingFrame);
        trackingFrame = 0;
        trackListItem(trackedLink());
        return;
      }
      scheduleRetrack();
    }

    function onFocusOut(event) {
      if (event.relatedTarget && list.contains(event.relatedTarget)) return;
      trackListItem(links[Math.max(0, activeIndex)].link);
    }

    window.addEventListener('resize', onResize);
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onDesktopChange);
    else if (desktopQuery.addListener) desktopQuery.addListener(onDesktopChange);
    list.addEventListener('focusout', onFocusOut);

    function cleanupTracking() {
      if (trackingFrame) window.cancelAnimationFrame(trackingFrame);
      trackingFrame = 0;
      window.removeEventListener('resize', onResize);
      if (desktopQuery.removeEventListener) desktopQuery.removeEventListener('change', onDesktopChange);
      else if (desktopQuery.removeListener) desktopQuery.removeListener(onDesktopChange);
      list.removeEventListener('focusout', onFocusOut);
    }

    var sentinel = document.createElement('span');
    sentinel.className = 'bn-article-layout__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    layout.appendChild(sentinel);
    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function () {
        selectFromGeometry();
      }, {
        root: null,
        rootMargin: '-' + (top + 24) + 'px 0px -65% 0px',
        threshold: [0, 1]
      });
      links.forEach(function (item) { observer.observe(item.target); });
      observer.observe(sentinel);
    }

    var cleanupDisclosure = setDisclosureMode(toc);
    setActive(0);
    toc.hidden = false;
    toc.dataset.bnArticleTocReady = 'true';
    layout.classList.add('bn-article-layout--ready');
    toc._bnArticleTocState = {
      bands: bands,
      cleanupBandObserver: cleanupBandObserver,
      cleanupDisclosure: cleanupDisclosure,
      cleanupTracking: cleanupTracking,
      clippingArticle: clippingArticle,
      context: context,
      layout: layout,
      links: links,
      list: list,
      observer: observer,
      onClick: onClick,
      onFocus: onFocus,
      sentinel: sentinel,
      tocHost: tocHost
    };
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-bn-article-toc]'), build);
    if (scope.matches && scope.matches('[data-bn-article-toc]')) build(scope);
  }

  window.BnArticleToc = {
    boot: boot,
    collectArticleEntries: collectArticleEntries,
    slug: slug,
    teardown: teardown
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  function teardownAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bn-article-toc]'), teardown);
  }

  document.addEventListener('shopify:section:unload', teardownAll);
  document.addEventListener('shopify:section:load', function () {
    teardownAll();
    window.requestAnimationFrame(function () { boot(document); });
  });
})();
